import { render, staticRenderFns } from "./order.vue?vue&type=template&id=cb2d582a&scoped=true&"
import script from "./order.vue?vue&type=script&lang=js&"
export * from "./order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb2d582a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb2d582a')) {
      api.createRecord('cb2d582a', component.options)
    } else {
      api.reload('cb2d582a', component.options)
    }
    module.hot.accept("./order.vue?vue&type=template&id=cb2d582a&scoped=true&", function () {
      api.rerender('cb2d582a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bill/finance/order.vue"
export default component.exports